module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/KathleenDeco_bottom-9b24ea7ffc4c6727d170864fbf86b3cb.png";